import { useEffect, useState } from 'react';
import { spotsApi, type CarMakeApi } from '../api/client';

export function useCarMakes() {
  const [carMakes, setCarMakes] = useState<CarMakeApi[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError(null);

    spotsApi.carMakes()
      .then((makes) => {
        if (cancelled) return;
        setCarMakes(makes);
      })
      .catch((err) => {
        if (cancelled) return;
        setCarMakes([]);
        setError(err instanceof Error ? err.message : 'Failed to load car makes.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { carMakes, loading, error };
}
